export function fileSizeFormat(bytes) {
  const megaBytes = bytes / (1024 * 1024);
  return `${Math.ceil(megaBytes * 100) / 100} MB`;
}
export default fileSizeFormat;
